import enterView from 'enter-view';

function enterViewTracking() {
  const elements = Array.from(
    document.querySelectorAll('[data-enter-view-tracking]'),
  );

  elements.length &&
    enterView({
      selector: elements,
      once: true,
      enter: (el) => {
        const eventId = el.dataset.enterViewTracking;

        if (!eventId) return;

        window.dataLayer &&
          window.dataLayer.push({
            event: eventId,
            eventAction: el,
          });
      },
    });
}

export function init() {
  enterViewTracking();
}
